import StringerCollection from "@/packages/stringer/src/StringerCollection";
import Stringer from "./Stringer";

export default {
	methods: {
		stringer(value) {
			return new Stringer(value);
		},
		stringerCollection(values) {
			return new StringerCollection(values);
		},
	},
};
